/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  
  class Register extends HTMLElement {
    constructor() {
      super();
    }  
    connectedCallback() {
      let value = ''

      // apply customer tag based on selected value
      document.getElementById('hear_about').addEventListener('change', function() {
        // get the value of the first select
        document.getElementById('aDDitude').style.display = 'none'
        document.getElementById('other').style.display = 'none'
        document.getElementById('doctor').style.display = 'none'

        value = this.value

        // show the secondary value for the 3 options bellow
        if(this.value == 'ADDitude') {
          document.getElementById('aDDitude').style.display = 'block'
        }
        if(this.value == 'Other') {
          document.getElementById('other').style.display = 'block'
        }
        if(this.value == 'Doctor Recommendation') {
          document.getElementById('doctor').style.display = 'block'
        }

        document.getElementById('customer_tags').value = 'h: ' + value
      })

      let secondaryValue = ''
      // apply the secodndary value if available
      document.querySelectorAll('.secondary-option').forEach(function(option) {
        let events = ['change', 'keyup']

        events.forEach(function(event) {
          option.addEventListener(event, function() {
            secondaryValue = value.includes('Doctor') ? this.value : value + ' ' + this.value
            document.getElementById('customer_tags').value = 'h: ' + secondaryValue
          })
        })
        
      })
    }
  }
  customElements.define('register-section', Register);



  class Apps extends HTMLElement {
    constructor() {
      super();
      function waitForShadowRootWithObserver(selector, callback) {
        const observer = new MutationObserver((mutationsList) => {
            const element = document.querySelector(selector);
            if (element && element.shadowRoot) {
                observer.disconnect(); 
                callback(element.shadowRoot); 
            }
        });
    
        observer.observe(document, {
            childList: true,
            subtree: true
        });
    
        const element = document.querySelector(selector);
        if (element && element.shadowRoot) {
            observer.disconnect(); 
            callback(element.shadowRoot);
        }
    }
    
    waitForShadowRootWithObserver('#app-embed', (shadowRoot) => {
      if(shadowRoot.querySelector('section[data-sizing="form-wrapper"]')) {
        shadowRoot.querySelector('section[data-sizing="form-wrapper"]').style.maxWidth = '100%';
        shadowRoot.querySelector('h2').style.fontFamily = 'tiffin-latin-variable, sans-serif';
      }

    });
    }
  }
  
  customElements.define('apps-section', Apps);


  class CookiesBanner extends HTMLElement {
    constructor() {
        super(); 
    }

    connectedCallback() {

        // Function to retrieve the banner element by its ID
        function getBannerEl() {
            return document.getElementById('cookies-banner'); 
        }

        // Function to hide the banner by setting its display to 'none'
        function hideBanner(res) {
            getBannerEl().style.display = 'none'; 
        }

        // Function to show the banner by setting its display to 'block'
        function showBanner() {
            getBannerEl().style.display = 'block'; 
        }

        // Function that handles the acceptance of cookies by the user
        function handleAccept(e) {
            // Set tracking consent for both analytics and marketing
            window.Shopify.customerPrivacy.setTrackingConsent({
                    analytics: true,
                    marketing: true,
                },
                hideBanner
            );

            document.addEventListener('trackingConsentAccepted', function () {
                console.log('trackingConsentAccepted event fired'); 
            });
        }

        // Function that handles the decline of cookies by the user
        function handleDecline() {
            // Set tracking consent to false for both analytics and marketing
            window.Shopify.customerPrivacy.setTrackingConsent({
                    analytics: false,
                    marketing: false,
                },
                hideBanner
            );
        }

        // Function that initializes the cookie banner based on current visitor consent
        function initCookieBanner() {
            const userConsent = window.Shopify.customerPrivacy.currentVisitorConsent(); 

            // If the user has not yet set consent for marketing or analytics, show the banner
            if (userConsent.marketing === '' || userConsent.analytics === '') {
                showBanner(); 
            }
        }

        // Load the Shopify Consent Tracking API to manage cookie consent
        window.Shopify.loadFeatures(
            [{
                name: 'consent-tracking-api',
                version: '0.1', 
            }],
            function (error) {
                if (error) {
                    throw error; 
                }

                initCookieBanner(); 
            }
        );

        // Attach event listener for 'Accept' button to handle cookie acceptance
        document.querySelector('.handleAccept').addEventListener('click', () => handleAccept());

        // Attach event listener for 'Decline' button to handle cookie decline
        document.querySelector('.handleDecline').addEventListener('click', () => handleDecline());
    }
}

customElements.define('cookies-banner', CookiesBanner);

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();




/**
------------------------------------------------------------------------------
  PDP: Product Details
  - Used inside element <product-details> in snippets/product.liquid
------------------------------------------------------------------------------
*/
class ProductDetails extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Update price after 1, 3, and 9 seconds due to 3rd party code loading latency
    [1000, 3000, 9000].forEach(delay => setTimeout(() => this.updatePrice(), delay));

    // Run immediately
    this.updatePrice();
  }

  updatePrice() {
    // Ensure required elements exist before attaching event listeners
    const activePriceLabel = document.querySelector('.rc-radio--active .price-label');
    const frequencyOptions = this.querySelector('.rc-widget');

    // Exit early if required elements not found
    if (!activePriceLabel || !frequencyOptions) return;

    // Prevent multiple event bindings
    if (this.hasAttribute('listeners-attached')) return;
    this.setAttribute('listeners-attached', 'true');

    // Update price when radio button is clicked
    this.querySelectorAll('.radio__button').forEach((radioButton) => {
      radioButton.addEventListener('click', () => {
        setTimeout(() => {
          const activeRadioLabel = document.querySelector('.rc-radio--active .price-label');
          if (!activeRadioLabel) return;

          // Extract price from active radio button text
          const priceText = activeRadioLabel.textContent.trim().split(' ')[0];
          const shownPrice = this.querySelector('.product__price--regular');

          if (shownPrice && priceText) {
            shownPrice.textContent = priceText;
          }
        }, 0);
      });
    });

    const self = this;
    // Update price when frequency option is clicked
    document.querySelectorAll('.rc-widget input[type="radio"]').forEach(function(option) {
      option.addEventListener('change', function() {
        setTimeout(() => {
          const priceLabel = document.querySelector('.rc-radio--active .price-label');
         
          if (!priceLabel) return;
      
          // Extract price from clicked frequency option
          const price = priceLabel.textContent.trim().split(' ')[0];
          const shownPrice = self.querySelector('.product__price--regular');

          if (shownPrice && price) {
            shownPrice.textContent = price;
          }
        }, 0);
      })
    })       
  }
}

customElements.define("product-details", ProductDetails);


// Sticky add to cart

class StickyAtc extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const self = this;

    self.getScrollChanges()
    self.changePrice()

    window.addEventListener('scroll', function() {
      self.getScrollChanges()
    })

    document.querySelector('.sticky-atc__variant button').addEventListener('click', function() {
      document.querySelector('.scroll-to-element').scrollIntoView({ behavior: 'smooth', block: 'start' });
    })

    if(document.querySelector('.product__submit__add')) {
      document.querySelector('.sticky-atc__button button').addEventListener('click', function() {
        document.querySelector('.product__submit__add').click()
      })
    }
   
    document.querySelector('product-details').addEventListener('click', function() {
      self.changePrice()
    })

    document.getElementById('SiteFooter').style.paddingBottom = '150px'
  }

  getScrollChanges() {
    const target = document.querySelector('.product__submit__add');
    if (target) {
      const rect = target.getBoundingClientRect();

      if (rect.bottom < 0) {
        document.querySelector('.sticky-atc').classList.add('active')

        if(document.querySelector('.zsiq_floatmain')) {
          document.querySelector('.zsiq_floatmain').style.bottom = document.querySelector('sticky-atc').offsetHeight + 20 + 'px'
        }

      } else {
        document.querySelector('.sticky-atc').classList.remove('active')

        if(document.querySelector('.zsiq_floatmain')) {
          document.querySelector('.zsiq_floatmain').style.bottom = '10px'
        }
      }
    }
  }

  changePrice() {
    setTimeout(() => {
      document.querySelector('.sticky-atc__button span').innerText = document.querySelectorAll('.product__price span')[0].innerText

      if(document.querySelector('input[data-product-select]')) {
        let id = document.querySelector('input[data-product-select]').value
        document.querySelectorAll('.sticky-atc__variant span').forEach(el => el.classList.add('hidden'))
        document.querySelector(`.sticky-atc__variant .variant-${id}`).classList.remove('hidden')
      }
    }, 10);
  }
}

customElements.define("sticky-atc", StickyAtc);


class SubscriptionWidget extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const self = this;

    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.matches && node.matches('.rc-widget')) {
            
            self.getPrices()
            observer.disconnect();

            const selectedOption = document.querySelector('.rc-widget input[type="radio"]:checked').value
            const targetRadio = self.querySelector(`input[type="radio"][value="${selectedOption}"]`);

            if (targetRadio) {
              targetRadio.checked = true;
              targetRadio.dispatchEvent(new Event('change', { bubbles: true }));
            }

            self.querySelectorAll('input[type="radio"]').forEach(function(option) {
              option.addEventListener('change', function() {
                let value = self.querySelector('input[type="radio"]:checked').value
                let target = document.querySelector(`.rc-widget input[type="radio"][value="${value}"]`)

                if (target) {
                  target.checked = true;
                  target.dispatchEvent(new Event('change', { bubbles: true }));
                }
              })
            })

            if(document.querySelector('.product__selectors')) {
              document.querySelectorAll('.product__selectors input').forEach(function(option) {
                option.addEventListener('change', function() {
                  const selectedValue = document.querySelector('input[data-single-option-selector]:checked')?.value
                  if(selectedValue.includes('1')) {
                    document.querySelector('.product-purchase_benefits.one-month').classList.remove('hidden')
                    document.querySelector('.product-purchase_benefits.three-month').classList.add('hidden')
                  } else {
                    document.querySelector('.product-purchase_benefits.one-month').classList.add('hidden')
                    document.querySelector('.product-purchase_benefits.three-month').classList.remove('hidden')
                  }
                  self.getPrices()
                })
              })
            }
          }
        });
      });
    });
    
    observer.observe(document.body, { childList: true, subtree: true });
  }

  getPrices() {
    document.querySelector('.product-purchase_option.onetime .product-purchase_price').innerHTML = document.querySelector('.rc-widget .onetime-radio .price-label').innerHTML
    document.querySelector('.product-purchase_option .product-purchase_compare_at').innerHTML = document.querySelector('.rc-widget .onetime-radio .price-label').innerHTML
    document.querySelector('.product-purchase_option .product-purchase_total').innerHTML = document.querySelector('.rc-widget .subscription-radio .price-label').innerHTML
  }
}

customElements.define("subscription-widget", SubscriptionWidget);